<template>
  <div :class='$style.login'>
    <h1 :class='$style.title'>新規登録</h1>
    <div :class="$style.next_button_wrap">
      <base-button display="inline-flex" width="100%" height="50px" @click="submit" :disabled="processing">
        スマホアプリを開く
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton/BaseButton'

export default {
  name: 'SsoRegistrationSpPage',
  components: { BaseButton },
  data() {
    return {
      processing: false
    }
  },
  computed: {
    mobileRegistrationUrl() {
      const baseUrl = process.env.VUE_APP_MOBILE_SAML_URL || ''
      const uuid = this.$route.query.uuid || ''
      return `${baseUrl}/open/sso/registration?uuid=${uuid}`
    }
  },
  methods: {
    async submit() {
      // スマホアプリの登録画面を開く処理
      if (this.mobileRegistrationUrl) {
        window.location.href = this.mobileRegistrationUrl
      }
    }
  }
}
</script>
<style lang='scss' module>
.login {
  display: flex;
  flex-direction: column;
  width: 375px;
  margin: 0 auto;
  padding: 68px 25px 47px 25px;
  box-sizing: border-box;
  text-align: left;

  @include mobile() {
    width: 375px;
    padding: 42px 32px 26px 32px;
  }
}

.title {
  margin-top: 0;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
  margin-bottom: 70px;

  @include mobile() {
    font-size: 24px;
    margin-bottom: 60px;
  }
}

.next_button_wrap {
  margin-top: 24px;
}
</style>
